import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiClickNowButton]',
})
export class ClickNowButtonDirective {
  @Output() clickNowButton = new EventEmitter();

  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    if (e.target instanceof HTMLElement && e.target.classList.contains('k-time-now')) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.clickNowButton.emit();
    }
  }
}
